import {
  PRODUCT_GET_PRO_LNGLIST_LIST_BEGIN,
  PRODUCT_GET_PRO_LNGLIST_LIST_SUCCESS,
  PRODUCT_GET_PRO_LNGLIST_LIST_FAILURE,
  PRODUCT_GET_PRO_LNGLIST_LIST_DISMISS_ERROR,
} from './constants';

import request from '../../../utils/request'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getPro_lnglistList(params) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: PRODUCT_GET_PRO_LNGLIST_LIST_BEGIN,
    });
    console.log(params)
    if (params) {
      params.size = 10;
    }

    const promise = new Promise((resolve, reject) => {
      request({
        method: 'get',
        url: '/api/gc/product/lng',
        data: params,
      }).then(data => {
        dispatch({
          type: PRODUCT_GET_PRO_LNGLIST_LIST_SUCCESS,
          data: Object.assign({}, data, { page: params ? params.page : '' }),
        });
        resolve(data);
      }).catch(error => {
        dispatch({
          type: PRODUCT_GET_PRO_LNGLIST_LIST_FAILURE,
          data: { error: error },
        });
        reject(error);
      })
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetPro_lnglistListError() {
  return {
    type: PRODUCT_GET_PRO_LNGLIST_LIST_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PRODUCT_GET_PRO_LNGLIST_LIST_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getPro_lnglistListPending: true,
        getPro_lnglistListError: null,
      };

    case PRODUCT_GET_PRO_LNGLIST_LIST_SUCCESS:
      // The request is success

      const byId = {};
      const items = [];
      action.data.data.forEach(item => {
        items.push(item.id);
        byId[item.id] = item;
      });
      return {
        ...state,
        pro_lnglistById: byId,
        pro_lnglistList: items,
        pro_lnglistPage: action.data.page,
        pro_lnglistSize: action.data.size,
        pro_lnglistTotal: action.data.totalCount,
        getPro_lnglistListPending: false,
        getPro_lnglistListError: null,
      };

    case PRODUCT_GET_PRO_LNGLIST_LIST_FAILURE:
      // The request is failed
      return {
        ...state,
        getPro_lnglistListPending: false,
        getPro_lnglistListError: action.data.error,
      };

    case PRODUCT_GET_PRO_LNGLIST_LIST_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getPro_lnglistListError: null,
      };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/features/product/redux/getPro_lnglistList.js